import { render, staticRenderFns } from "./BIParameterRuleStepper.vue?vue&type=template&id=56d109c8&"
import script from "./BIParameterRuleStepper.vue?vue&type=script&lang=js&"
export * from "./BIParameterRuleStepper.vue?vue&type=script&lang=js&"
import style0 from "./BIParameterRuleStepper.vue?vue&type=style&index=0&id=56d109c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports